// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-data{width:100%;display:flex;justify-content:space-between}.card-data__container{flex-grow:1}.card-data__unit{text-transform:capitalize;color:var(--color-black)}.card-data__label-container{padding-left:0}.card-data__label{line-height:20px}.card-data__item{display:flex}.card-data__item ul{margin-block-start:0;margin-block-end:0;padding-inline-start:15px}", ""]);
// Exports
module.exports = exports;
